<header class="account-cards-header">
  <h3 class="account-cards-title">{{ 'payment_cards' | translate }}</h3>
  <p *ngIf="hasCards" class="account-cards-subtitle">{{ 'payment_cards_text' | translate }}</p>
</header>
<main class="account-cards-body">
  <ng-container *ngIf="loading; else loaded">
    <div class="card-skeleton"></div>
    <div class="card-skeleton"></div>
    <div class="card-skeleton"></div>
  </ng-container>
  <ng-template #loaded>
    <div *ngIf="hasCards" class="account-cards-container">
      <account-card
        *ngFor="let card of cards"
        [card]="card"
        [canDelete]="false"
        [canEdit]="true"
        (editCard)="onEditCard()"
        [tabIndex]="0"
        [ariaLabel]="card.pan"
      ></account-card>
    </div>
    <div *ngIf="!hasCards" class="account-cards-empty-state">
      <h5 class="account-cards-empty-state-title">{{ 'no_saved_cards' | translate }}</h5>
      <i class="account-cards-empty-state-icon"></i>
      <p class="account-cards-empty-state-subtitle">{{ 'add_new_card_info_text' | translate }}</p>
    </div>
  </ng-template>
</main>
